module.exports = __webpack_public_path__ + "img/jishu2.81fff0d5.png";